"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var React = _interopRequireWildcard(require("react"));

var PropTypes = _interopRequireWildcard(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _DividedContent = _interopRequireDefault(require("./DividedContent.css"));

var DividedContent =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(DividedContent, _React$PureComponent);

  function DividedContent() {
    (0, _classCallCheck2.default)(this, DividedContent);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(DividedContent).apply(this, arguments));
  }

  (0, _createClass2.default)(DividedContent, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          panes = _this$props.panes;
      return React.createElement("div", {
        className: classes.container
      }, panes.map(function (content, index) {
        return React.createElement("div", {
          key: index,
          className: classes.pane
        }, content);
      }));
    }
  }]);
  return DividedContent;
}(React.PureComponent);

DividedContent.propTypes = {
  /**
   * The panes that will be displayed.
   */
  panes: PropTypes.arrayOf(PropTypes.node).isRequired
};

var _default = (0, _styles.withStyles)(_DividedContent.default)(DividedContent);

exports.default = _default;